export default __webpack_public_path__ + "static/media/AWEbase-logo-unlinked-contractor.960959df.svg";